import React, { useEffect } from 'react'
import styled from 'styled-components'
import Alert from '../../../../assets/images/Alert.svg'
import { Flex, ResponsiveSVG } from 'ui/acro'

const SnackBar = styled(Flex)({
  justifyContent: 'flex-start',
  gap: '12px',
  fontFamily: 'Proxima-Nova',
  color: '#B00020',
  fontSize: '16px',
  fontStyle: 'normal',
  fontWeight: '600',
  lineHeight: '24px',
  letterSpacing: '0.352px',
  padding: '16px',
  alignItems: 'center',
  alignSelf: 'stretch',
  background: '#FDECEA',
  borderRadius: '8px',
  visibility: 'hidden',
  opacity: '0',
  boxShadow:
    '0px 4px 8px 0px rgba(0, 0, 0, 0.06), 0px 12px 32px 0px rgba(35, 41, 54, 0.14)',
  '&.show-alert': {
    visibility: 'visible',
    opacity: '1'
  }
})

const IncorrectOtpError = ({ message, show, onClose }) => {
  useEffect(() => {
    if (show) {
      const timer = setTimeout(onClose, 3000) // auto-hide after 3 sec
      return () => clearTimeout(timer)
    }
  }, [show, onClose])

  return (
    <SnackBar className={show ? 'show-alert' : ''}>
      <ResponsiveSVG
        SVG={Alert}
        style={{
          cursor: 'pointer'
        }}
        width='20px'
        height='20px'
      />
      {message}
    </SnackBar>
  )
}

export default IncorrectOtpError
